import React from 'react'
import DebugVM from './DebugVM'
import { Input, Button, InputBasic } from 'ui-framework'
import { observer } from 'mobx-react'
import { autoFormat } from 'app-lib/numberUtils'
import SpendingApprovals from './SpendingApprovals'

function Debug({ vm }: { vm: DebugVM }) {
  const { web3Connection, userWallet, settings } = vm.rootStore

  return (
    <div className="margin-bottom-4">
      <div className="grid-fluid-colmin-20em">
        <div className="panel--simple padded-2">
          <h3 className="title-section">Version</h3>
          {process.env.APP_VERSION} {`Commit ${process.env.GIT_COMMIT}`}
        </div>
        <div className="panel--simple padded-2">
          <h3 className="title-section">Impersonate 🕵️</h3>
          <form className="impersonate-container" onSubmit={vm.setImpersonate}>
            <div className="input-with-sticked-btn">
              <Input
                id="impersonate-address"
                placeholder="address"
                onChange={vm.set}
                onChangeEmit="name-value"
                name="inputImpersonate"
                value={vm.inputImpersonate}
              />
              <Button variant="green" type="submit" disabled={!vm.inputImpersonateValid}>
                {vm.inputImpersonate === '' && web3Connection.impersonateAddress
                  ? 'Stop impersonate'
                  : 'Submit'}
              </Button>
            </div>
          </form>
          {web3Connection.impersonateAddress && (
            <>
              <p className="txt-positive txt-bold margin-top-2">
                Currently impersonating:{' '}
                <span title={web3Connection.impersonateAddress}>
                  {web3Connection.shortWalletAddress}
                </span>
              </p>
            </>
          )}
        </div>
      </div>
      {web3Connection.impersonateAddress && (
        <div className="panel--simple padded-2 margin-top-1">
          <h3 className="title-section">🕵️ Impersonated user balances</h3>
          <div className="debug__balances">
            <b>
              {userWallet.nativeBalance.token}{' '}
              <span title={userWallet.nativeBalance.amount.toFixed()}>
                {autoFormat(userWallet.nativeBalance.amount)}
              </span>
            </b>
            {userWallet.balances
              .filter((balance) => !balance.amount.isZero())
              .map((balance) => (
                <div key={balance.token}>
                  {balance.token}{' '}
                  <span title={balance.amount.toFixed()}>{autoFormat(balance.amount)}</span>
                </div>
              ))}
          </div>
        </div>
      )}

      <SpendingApprovals vm={vm} />

      <div className="panel--simple padded-2 margin-top-1">
        <h3 className="title-section">Options</h3>
        <div>
          <InputBasic
            id="input-onchain"
            type="checkbox"
            onChange={settings.set}
            onChangeEmit="name-value"
            name="fetchRatesOnChain"
            value={settings.fetchRatesOnChain}
          />
          <label className="margin-left-1ch txt-alternate" htmlFor="input-onchain">
            Fetch rates onchain (bypass backend api)
          </label>
        </div>
        <div className="margin-top-1">
          <InputBasic
            id="input-debugtx"
            type="checkbox"
            onChange={settings.set}
            onChangeEmit="name-value"
            name="debugTx"
            value={settings.debugTx}
          />
          <label className="margin-left-1ch txt-alternate" htmlFor="input-debugtx">
            Log Transactions details
          </label>
        </div>
        <div className="margin-top-1">
          <InputBasic
            id="input-devMode"
            type="checkbox"
            onChange={settings.set}
            onChangeEmit="name-value"
            name="devMode"
            value={settings.devMode}
          />
          <label className="margin-left-1ch txt-alternate" htmlFor="input-devMode">
            Development mode
          </label>
        </div>
        <div className="flex-row-center margin-top-1">
          <label
            className="margin-right-1ch txt-alternate"
            htmlFor="input-override-protocol-version">
            Override protocol version
          </label>
          <select
            value={settings.protocolVersionOverride}
            id="input-override-protocol-version"
            onChange={vm.setProtocolVersion}>
            <option value="-1">No override</option>
            <option value="4">4 | itoken as collateral</option>
          </select>
        </div>
        <div className="txt-warning txt-read-optimized">
          Note: this will override the version for all chains configs. So any chain which contracts
          does not match the version will fail on breaking changes.
        </div>
      </div>
    </div>
  )
}

export default observer(Debug)
